import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  service_list_action,
  service_delete_action,
} from "../../../actions/master_actions/service_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";
import { StatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      servicesData: [],
      userId: "",
      AdditionalServicesID: "",
      Code: "",
      Name: "",
      PricingOn: "",
      HSNCode: "",
      GST: "",
      Status: "",
      ServiceAccount: "",
      Description: "",
      currentPage: 1,
      isAccordionExpanded: false,statusFillList: [],
    };
    this.serviceList = this.serviceList.bind(this);
    this.updateItem=this.updateItem.bind(this);
    this.servicesRecord=this.servicesRecord.bind(this);
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.serviceList();    this.getFillList(StatusActionId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  navigateServiceUpdate(AdditionalServicesID) {
    console.log(AdditionalServicesID);
    this.props.navigate("/additional_services_add", {
      state: { AdditionalServicesID: AdditionalServicesID },
    });
  }

  navigateServiceAdd() {
    const { servicesData } = this.state;
    let maxCode = -1;
   servicesData.forEach((service) => {
      const codeNumber = parseInt(service.Code.substring(2), 10);
      if (!isNaN(codeNumber) && codeNumber > maxCode) {
        maxCode = codeNumber;
      }
    });
   let newCode;
    if (maxCode < 9) {
      newCode = `AS0${maxCode + 1}`;
    } else {
      newCode = `AS${maxCode + 1}`;
    }
    
    this.props.navigate("/additional_services_add", { state: { Code: newCode } });
  }
  serviceList (){
    const { Name, Code, Status } = this.state;
    const finalStatus = Status == "InActive" ? 0 : Status=="Active"?1:null;
    this.setState({ isLoading: true });
    this.props
      .service_list_action( Name, Code, finalStatus)
      .then((data) => {
        console.log(data, "from UI service");
        if (data.error !== 1) {
          this.setState({
            servicesData: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.servicesData);
    }, 500);
  };
  handleDelete(AdditionalServicesID) {
    const userId = 0;

    const confirmed = window.confirm(
      "Are you sure you want to delete this Additional Service?"
    );

    if (confirmed) {
      this.props
        .service_delete_action(AdditionalServicesID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.serviceList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  

  updateItem(item) {
    this.setState({ currentPage: item });
  }
  servicesRecord(servicesData) {
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
            <th>Service Code</th>
            <th>Service Name</th>
            <th>Pricing on</th>
            <th>HSN Code</th>
            <th>GST %</th>
            <th>Status</th>
            <th className="text-right" style={{ width: "5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {servicesData != "" && servicesData != null ? (
            servicesData.map((item) => (
              <tr>
                <td>{item.Code}</td>
                <td>{item.Name}</td>
                <td>{item.PricingOn}</td>
                <td>{item.HSNCode}</td>
                <td>{item.GST}</td>
                <td>{item.Status==1?"Active":"InActive"}</td>
                <td className="text-right">
                  <a
                    href="javascript:void(0);"
                    onClick={() =>
                      this.navigateServiceUpdate(item.AdditionalServicesID)
                    }
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {item.Status==1?(
                  <a
                    href="javascript:void(0);"
                    onClick={() => this.handleDelete(item.AdditionalServicesID)}
                    title="Delete"
                    className="btn btn-sm delete_record"
                  >
                    <i className="fa fa-trash action_btn_table" />
                  </a>):<></>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colspan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      servicesData,
      AdditionalServicesID,statusFillList,
      currentPage,
      isAccordionExpanded,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = servicesData.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(servicesData.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[10]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Additional Services</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateServiceAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5 className="info">
                            Service Code : <span>{this.state.Code}</span>
                          </h5>
                          <h5 className="info">
                            Service Name : <span>{this.state.Name}</span>
                          </h5>
                          <h5 className="info">
                            Status : <span>{this.state.Status}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Service Code</label>
                                <input
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({ Code: e.target.value })
                                  }
                                  value={this.state.Code}
                                  className="form-control search_form_control"
                                  placeholder="Enter Service Code"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Service Name</label>
                                <input
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                  value={this.state.Name}
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Service Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={this.state.Status}
                                  onChange={(e) =>
                                    this.setState({ Status: e.target.value })
                                  }
                                >
                                  <option>Select Status</option>
                                  {statusFillList.length > 0
                                    ? statusFillList.map((data) => (
                                        <option
                                          key={data.Status}
                                          value={data.Status}
                                        >
                                          {data.Status}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                              {console.log(this.state.Status)}
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={()=>this.serviceList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                               onClick={()=>{
                                this.setState({
                                  Name:"",
                                  Code:"",
                                  Status:""
                                },()=>this.serviceList())
                              }}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.servicesRecord(currentRecords)}
                      {servicesData.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { service_list_action, service_delete_action ,fill_action})(Services)
);
